import api, { CustomerWireInfo } from '@api';
import { RoutedDialog, RoutedDialogProps } from '@tsp-ui/core/components';
import { useAsyncEffect, usePageMessage, useParams } from '@tsp-ui/core/utils';
import { AdminRouteParams } from '@views/admin/components/AdminPageTemplate';
import { useCallback, useState } from 'react';

import WireInstructionsAddEditContent from './WireInstructionsAddEditContent';
import WireInstructionsListContent from './WireInstructionsListContent';


export default function WireInstructionsDialog(props: Omit<RoutedDialogProps, 'title' | 'children'>) {
    const { customerID } = useParams<AdminRouteParams<'customer'>>();

    const [ wireInstructionsToEdit, setWireInstructionsToEdit ] = useState<CustomerWireInfo | {}>();
    const [ wireInstructionsArray, setWireInstructionsArray ] = useState<CustomerWireInfo[]>([]);
    const [ loading, setLoading ] = useState(false);

    const pageMessage = usePageMessage();

    const onApprove = (id: string) => {
        setWireInstructionsArray(wireInstructionsArray.map(wireInfo => (id === wireInfo.id ? {
            ...wireInfo,
            isApproved: true
        } : wireInfo)));
    };

    const onToggleActive = (id: string) => {
        setWireInstructionsArray(wireInstructionsArray.map(wireInfo => (id === wireInfo.id ? {
            ...wireInfo,
            isActive: !wireInfo.isActive
        } : wireInfo)));
    };

    const onAdd = (res: CustomerWireInfo) => {
        const newArray = [ ...wireInstructionsArray ];
        newArray.push(res);
        setWireInstructionsArray(newArray);
    };

    const onEdit = (formValues: CustomerWireInfo) => {
        setWireInstructionsArray(wireInstructionsArray.map(
            wireInfo => (formValues.id === wireInfo.id ? formValues : wireInfo)
        ));
    };

    useAsyncEffect(useCallback(async () => {
        setLoading(true);

        try {
            setWireInstructionsArray(await api.customer.wireInfo.getWireInfo(customerID));
        } catch (error) {
            pageMessage.handleApiError('An error occurred while fetching the wire instructions', error);
        }

        setLoading(false);
    }, [ pageMessage, customerID ]));

    return (
        <RoutedDialog
            title="Wire instructions"
            {...props}
            maxWidth={false}
            loading={loading}
        >
            {wireInstructionsToEdit
                ? (
                    <WireInstructionsAddEditContent
                        defaultValues={wireInstructionsToEdit}
                        onAdd={onAdd}
                        onEdit={onEdit}
                        setWireInstructionsToEdit={setWireInstructionsToEdit}
                    />
                ) : (
                    <WireInstructionsListContent
                        wireInstructionsArray={wireInstructionsArray}
                        onApprove={onApprove}
                        onToggleActive={onToggleActive}
                        setWireInstructionsToEdit={setWireInstructionsToEdit}
                    />
                )}
        </RoutedDialog>
    );
}
